// extracted by mini-css-extract-plugin
export default {"root":"maintenance_root__SdTwG","logo":"maintenance_logo__HCh78","header":"maintenance_header__3VPRD","content":"maintenance_content__mJXpV","cactus":"maintenance_cactus__7PTqU"};